import React from 'react'

const DatabaseAdministration = () => {
  return (
    <div>DatabaseAdministration</div>
  )
}

export default DatabaseAdministration